export default {
  'Translation test': 'Test der Übersetzungen',
  'Type name': 'Bezeichnung angeben',
  Logout: 'Ausloggen',
  'My Courses': 'Meine Kurse',
  'Direct Access': 'Direct Access',
  Mentor: 'MentorIn',
  'Prev page': 'Vorherige',
  'Next page': 'Nächste',
  '5 pages forward': 'Zurück um 5',
  '5 pages next': 'Nach vorne um 5',
  'You must have at least 70% to complete the quest':
    'Damit eine Aufgabe angerechnet werden kann, müssen Sie wenigstens 70%',
  'pts.': 'Punkte',
  'Refresh quiz result. Available once every minute.':
    'Quizergebnis aktualisieren. Einmal pro Minute verfügbar',
  'Go to top': 'Gehen Sie nach oben',
  Previous: 'Zurück',
  Next: 'Weiter',
  'Your result': 'Ihr Ergebnis',
  'How do you rate the': 'Wie beurteilen Sie das',
  'Why ?': 'Warum?',
  Send: 'Senden',
  'Find by signature': 'Nach Signatur suchen',
  'Currently you are not assigned to any course. Please contact course specialist.':
    'Zurzeit haben Sie Zugriff auf keinen Kurs. Setzen Sie sich mit Ihrem Betreuer in Verbindung, um den Zugriff auf den Kurs zu erhalten.',
  'Currently you are not assigned to any course.':
    'Zurzeit haben Sie Zugriff auf keinen Kurs.',
  'No records found': 'Es wurden keine Datensätze gefunden',
  'You are not assigned to any course. Please contact course specialist.':
    'Sie wurden keinem Kurs zugewiesen. Setzen Sie sich mit Ihrem Betreuer in Verbindung.',
  'Internet connection lost': 'Kein Internetzugriff',
  Learning: 'Lernen',
  Exams: 'Prüfungen',
  'Links & information': 'Links und Informationen',
  Module: 'Modul',
  Mode: 'Modus',
  Courses: 'Kurse',
  Chapter: 'Kapitel',
  Subject: 'Thema',
  Open: 'Öffnen',
  Download: 'Herunterladen',
  article: 'Artikel',
  presentation_pdf: 'Präsentation',
  presentation_reveal: 'Präsentation',
  presentation: 'Präsentation',
  presentations: 'Präsentationen',
  exercise: 'Aufgabe',
  attachment: 'Anhang',
  quiz: 'Quiz',
  snippet: 'Code-Ausschnitt',
  Quizzes: 'Quiz',
  Exercises: 'Aufgaben',
  Materials: 'Materialien',
  'Learning results': 'Lernfortschritt',
  'Learning report': 'Lernbericht',
  'Exams results': 'Ergebnisse der Prüfungen',
  'Page not found': 'Die Seite mit der angegebenen Adresse existiert nicht',
  'Go to courses page': 'Zur Seite mit Kursen übergehen',
  'is not available yet': 'Noch nicht verfügbar',
  Result: 'Ergebnis',
  'Number of quizzes passed': 'Anzahl der angerechneten Quiz',
  'Number of exercises passed': 'Anzahl der angerechneten Aufgaben',
  'Pass criteria are at least': 'Anrechnungskriterien sind wenigstens',
  'You must have at least to pass':
    'Um ein Quiz anzurechnen, müssen Sie wenigstens ... haben',
  Edit: 'Bearbeiten',
  Save: 'Speichern',
  'See the solution': 'Lösung sehen',
  Chat: 'Chat',
  'Virtual Classroom': 'Virtuelle Klasse',
  'Download the schedule': 'Ablaufplan herunterladen',
  Student: 'Kursteilnehmer',
  'E.': 'Z.',
  'Admin panel': 'Administrator-Paneel',
  'Automatic test result': 'Ergebnis des automatischen Tests',
  'Result edited by lecturer':
    'Das Ergebnis wird durch den Lehrbeauftragten bearbeitet',
  'Take this quiz. You can approach the quiz many times. The highest score is included in the score.':
    'Bitte machen Sie jetzt das Quiz. Sie können dasselbe Quiz mehrmals lösen. Zur Auswertung wir dann das beste Ergebnis herangezogen. ',
  'The quiz result may refresh with a delay of several minutes.':
    'Bei der Aktualisierung des Quiz-Ergebnisses kann es zu einer Verzögerung von einigen Minuten kommen.',
  'Go to repository': 'Zum Repository',
  'Something went wrong': 'Etwas ist schief gegangen',
  'This quiz is not available yet': 'Dieses Quiz ist noch nicht verfügbar',
  Sharing: 'Lerninhalte',
  Gradebook: 'Bewertung',
  Product: 'Produkt',
  Version: 'Version',
  material_type_for_rate_presentation: 'Präsentation',
  material_type_for_rate_presentation_pdf: 'Präsentation',
  material_type_for_rate_presentation_reveal: 'Präsentation',
  material_type_for_rate_exercise: 'Aufgabe',
  material_type_for_rate_attachment: 'Anhang',
  material_type_for_rate_quiz: 'Quiz',
  material_type_for_rate_article: 'Artikel',
  material_type_for_rate_snippet: 'Code-Ausschnitt',
  'Add results': 'Ergebnisse hinzufügen',
  Recordings: 'Aufnahmen',
  'Internal Server Error': 'Interner Serverfehler',
  'Bad Request': 'Nicht korrekte Anfrage',
  Unauthorized: 'Nicht autorisierter Zugriff',
  'Not Found': 'Der Bestand wurde nicht gefunden',
  'Bad Gateway': 'Der Server kann die Aufforderung nicht realisieren',
  'Back to top': 'Zurück nach oben',
  'select exam': 'Prüfung auswählen',
  'Are you sure you want to revoke access to materials?':
    'Wollen Sie wirklich den Zugriff auf Materialien entziehen?',
  'Are you sure you want to revoke access to exam?':
    'Wollen Sie wirklich den Zugriff auf Prüfung entziehen?',
  'Results and the repository with the solutions will be deleted.':
    'Wenn die Zugriffsrechte zurückgezogen werden, werden auch die Ergebnisse sowie das Repositorium inkl. Lösungen gelöscht..',
  Yes: 'Ja',
  No: 'Nein',
  'Student / Module': 'Kursteilnehmer / Modul',
  'Lecturer / Module': 'Lehrbeauftragter / Modul',
  'All students': 'Alle Studenten',
  'There are no shared exams': 'Keine zur Verfügung gestellten Prüfungen',
  Initial: 'Initialisierung',
  'Build in progress': 'Bauvorgang im Gange',
  'Build failed': 'Fehler beim Bauvorgang',
  'Build succeed': 'Gebaut',
  'Not shared': 'Nicht zur Verfügung gestellt',
  Shared: 'Zur Verfügung gestellt',
  Share: 'Zur Verfügung stellen',
  'Share exams': 'Prüfungen zur Verfügung stellen',
  'Revoke share': 'Zugriff entnehmen',
  'Building succeed': 'Der Bauvorgang wurde erfolgreich abgeschlossen',
  'Building not succeed':
    'Der Bauvorgang konnte nicht erfolgreich abgeschlossen werden',
  Retry: 'Wiederholen',
  course: 'Kurs',
  signature: 'Signatur',
  'Chapter content': 'Inhalt des Kapitels',
  'Ready for shared': 'Fertig zum Zurverfügungstellen',
  'You Are Not Allowed to Access This Page':
    'Sie haben keinen Zugriff auf diese Seite',
  'No Github account': 'Kein Github-Konto',
  'Github nick': 'Bezeichnung Github',
  'Connect your account with GitHub to have access for course materials and solve exercise. Log in to your GitHub account or create new - click':
    'Verknüpfen Sie das Konto mit GitHub, um sich den Zugriff auf erforderliche Kursmaterialien zu sichern und Aufgaben lösen zu können. Loggen Sie sich auf Ihr Github-Konto oder legen Sie ein neues Konto an - klicken Sie',
  here: 'hier',
  'Students reviews report': 'Bericht zu den Bewertungen der Kursteilnehmer',
  from: 'von',
  to: 'bis',
  'Download report': 'Bericht herunterladen',
  'Show menu': 'Menü zeigen',
  less: 'Weniger',
  more: 'Mehr',
  'Pass criteria': 'Bewertungskriterien',
  'Github account': 'Konto Github',
  'Student name': 'Vor- und Nachname',
  Comments: 'Kommentare',
  'No comments yet.': 'Es wurde bis jetzt kein Kommentar hinzugefügt',
  Summary: 'Zusammenfassung',
  Rated: 'Bewertet',
  'Publish results': 'Ergebnis veröffentlichen',
  'Unpublish results': 'Veröffentlichung zurückziehen',
  'Link to repository': 'Link zum Repositorium',
  'Are you sure you want to grant access to materials for all students?':
    'Wollen Sie wirklich die Materialien allen Kursteilnehmern zur Verfügung stellen?',
  Copy: 'Kopieren',
  'Go to Gradebook': 'Gehen Sie zum bewertung über',
  'Download presentation': 'Präsentation herunterladen',
  Fullscreen: 'Vollbildschirm',
  'Close fullscreen': 'Vollbildschirmmodus schließen',
  'Building and sharing is handled by the queue. Click refresh button if the status has not changed.':
    'Der Bauvorgang und die Zurverfügungstellung erfolgen über eine Warteschlange, klicken Sie auf die Schaltfläche Aktualisieren, wenn sie wollen, dass der Status geändert wird.',
  Refresh: 'Aktualisieren',
  'Repository not shared': 'Repositorium wurde nicht zur Verfügung gestellt',
  'Repositories not shared': 'Repositorien wurden nicht zur Verfügung gestellt',
  'Share failed':
    'Zurverfügungstellung konnte nicht erfolgreich abgeschlossen werden',
  'Repository build but not shared':
    'Repositorium gebaut, nicht zur Verfügung gestellt',
  'Only repositories will be shared':
    'Es werden nur Repositorien zur Verfügung gestellt',
  'Send team invitation': 'Einladung zum Team übersenden',
  'Send team invitation for github again':
    'Senden Sie erneut eine Einladung zum Team auf github',
  'Your courses': 'Ihre Kurse',
  "Don't show this screen after logging in":
    'Diesen Bildschirm nach dem Einloggen nicht anzeigen',
  'Course Specialist': 'Betreuer',
  Current: 'Status',
  Signature: 'Signatur',
  Schedule: 'Ablaufplan',
  'Show chapters': 'Kapitel einblenden',
  'Hide chapters': 'Kapitel ausblenden',
  'Continue learning': 'Lernvorgang fortsetzen',
  articles: 'Artikel',
  quizzes: 'Quiz',
  exercises: 'Aufgaben',
  attachments: 'Anhänge',
  snippets: 'Snippets',
  'lecturer materials': 'Materialien des Lehrbeauftragten',
  Search: 'Suchen',
  More: 'Mehr',
  'Course schedule': 'Ablaufplan des Kurses',
  Profile: 'Profil',
  'Name and surname': 'Vor- und Nachname',
  Password: 'Passwort',
  'Not linked': 'Nicht verbunden',
  'Link your GitHub account to Coders Lab profile to be able to solve the exercise and proceed the exam':
    'Verknüpfen Sie das GitHub-Konto mit dem Coders Lab Profil, um die Aufgaben zu benutzen und die Prüfung abzulegen',
  'Link accounts': 'Konten verknüpfen',
  'Old password': 'Altes Passwort',
  'New password': 'Neues Passwort',
  'Retry new password': 'Neues Passwort wiederholen',
  'Wrong password': 'Falsches Passwort',
  Name: 'Vorname',
  Surname: 'Nachname',
  'User profile': 'Benutzerprofil',
  Rate: 'Bewerten',
  'Comment has required!': 'Kommentar ist nicht erforderlich!',
  'Request issue': 'Anmerkung anmelden',
  'Add issue': 'Anmerkung hinzufügen',
  'Enter a comment': 'Geben Sie einen Kommentar ein',
  'Non scored': 'Es werden keine Punkte vergeben',
  'Not started': 'Nicht angefangen',
  'In progress': 'Im Gange',
  Pass: 'Angerechnet',
  'Pass 100%': 'Angerechnet mit 100%',
  'Select the part of content you want to comment':
    'Markieren Sie den Abschnitt, an den Sie eine Anmerkung vorbringen möchten',
  Add: 'Hinzufügen',
  Cancel: 'Annullieren',
  'Add comment': 'Kommentar hinzufügen',
  'Your opinion': 'Ihre Meinung',
  Read: 'Gelesen',
  'Wrong name': 'Falscher Vorname',
  'Wrong surname': 'Falscher Name',
  'Passwords must be the same': 'Das Passwort muss identisch sein',
  Lecturer: 'Lehrbeauftragter',
  Records: 'Aufnahmen',
  Change: 'Ändern',
  'Your account has been linked to Github. Now you will have access to the materials.':
    'Ihr Konto wurde mit Github verknüpft. Jetzt werden Sie den Zugriff auf erforderliche Materialien haben.',
  Welcome: 'Willkommen',
  'To access the course': 'Um auf den Kurs zuzugreifen',
  'contact your course specialist': 'kontaktiere deinen kursspezialisten',
  'or find a course for yourself in the': 'oder finde einen Kurs für dich im',
  'Course Offer.': 'Kursangebot.',
  Done: 'Erledigt',
  'Open in fullscreen': 'Im Vollbildmodus öffnen',
  'Search phrase': 'Suchbegriff',
  'Search filter': 'Suchfilter',
  'all materials': 'alle Materialien',
  'Show more': 'Mehr anzeigen',
  'Available later in the course':
    'Im Kurs zu einem späteren Zeitpunkt verfügbar',
  'Remove selection': 'Auswahl entfernen',
  'Sorry, the server cannot show this page':
    'Entschuldigen Sie, der Server kann diese Seite nicht anzeigen',
  'Enter the phrase, minimum 3 characters':
    'Geben Sie die Phrase mit mindestens 3 Satzzeichen ein',
  'Enter phrase, min. 3 characters': 'Phrase eingeben, min 3 Satzzeichen',
  'Close the search and go back to previous page':
    'Schließen Sie die Suche und gehen Sie zurück zur vorherigen Seite',
  'Close search results': 'Suchergebnisse schließen',
  'Please add your comment': 'Bitte fügen Sie Ihren Kommentar hinzu',
  'Similar search results': 'Ähnliche Suchergebnisse:',
  'Exact results not found.': 'Genaue Ergebnisse nicht gefunden.',
  Language: 'Sprache',
  'Checking in progress': 'Überprüfung im Gange',
  Unchecked: 'Nicht bewertet',
  'Click publish to see a score summary':
    'Klicken Sie auf Veröffentlichen, um eine Gesamtpunktezahl zu sehen',
  Published: 'Veröffentlicht',
  Publish: 'Veröffentlichen',
  'It is required to check all tasks - complete the score':
    'Es ist erforderlich, alle Aufgaben zu überprüfen um die Punkte zu  vervollständigen',
  'Learning progress': 'Lernfortschritt',
  'Report for: ': 'Bericht für: ',
  'With modules': 'Mit Modulen',
  'With chapters': 'Mit Kapiteln',
  'With materials': 'Mit Materialien',
  'Progress report': 'Fortschrittsbericht',
  'Free course': 'Kostenloser Kurs',
  'User already exists': 'Benutzer existiert bereits',
  'Email not received?': 'E-Mail nicht erhalten?',
  'Send it again.': 'Erneut senden.',
  'Privacy policy':
    'By registering, you accept <a href="https://coderslab.com/en/regulations" target="_blank">the Terms and Conditions</a> and <a href="https://coderslab.com/en/privacy-policy" target="_blank"> the Privacy Policy</a>.',
  'no account': 'kein Account',
  Modules: 'Modulen',
  'Students on page:': 'Schüler auf Seite:',
  'No students on the course': 'Keine Studenten im Kurs',
  'Instance id is missing': 'Select a course',
};
